export const MILLISECONDS_PER_MINUTE = 60000;

export const MINUTES_PER_HOUR = 60;

export const UNNAMED_USER_TEXT = 'Unnamed';

export const DEFAULT_MAX_AVATARS = 6;
